export var isBrandInNAM = function isBrandInNAM(brand) {
  return (brand === null || brand === void 0 ? void 0 : brand.based_in) === "USA" || (brand === null || brand === void 0 ? void 0 : brand.based_in) === "CAN";
};